import React, { Component } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHEContainer, FHETitle, SubMenuVertical } from 'data/components';
import { SvgHome, SvgBox, SvgUser, SvgProduct, SvgTicket, SvgJournalisation, SvgHistory } from 'data/common/iconsvg';
import { Toastr } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { HomeDetails, HomeBox, HomeUsers, HomeProducts, HomeTickets, Journalisation, History } from './sections';
import getSelectors from './selectors';
import getMiddlewareSocketInstance from '../../common/SocketMiddleware';
import SvgStats from '../../../../data/common/iconsvg/SvgStats';
import Stats from './sections/Stats';

class HomeDetail extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        homeLabel: PropTypes.string,
        boxId: PropTypes.number,
        boxVersion: PropTypes.string,
        boxMac: PropTypes.string,
        homeId: PropTypes.string.isRequired
    };
    static defaultProps = {
        boxId: null,
        homeLabel: '',
        boxVersion: '',
        boxMac: ''
    };
    constructor(props) {
        super(props);
        const { history } = props;
        this.allTabList = {
            details: {
                label: Translator.translate('general.home'),
                Icon: SvgHome,
                View: HomeDetails,
                right: 'homeDetails'
            },
            box: {
                firstTab: true,
                label: Translator.translate(`${history.environment}.centerName`),
                Icon: SvgBox,
                View: HomeBox,
                right: `boxDetails_${history.environment}`
            },
            users: {
                label: Translator.translate('general.Users'),
                Icon: SvgUser,
                View: HomeUsers,
                right: `homeUsers_${history.environment}`
            },
            products: {
                label: Translator.translate('general.Products'),
                Icon: SvgProduct,
                View: HomeProducts,
                right: 'productsList'
            },
            tickets: {
                label: Translator.translate('general.tickets'),
                Icon: SvgTicket,
                View: HomeTickets,
                right: 'ticketList'
            },
            history: {
                label: Translator.translate('general.history'),
                Icon: SvgHistory,
                View: History,
                right: `homeHistory_${history.environment}`
            },
            journalisation: {
                label: Translator.translate('general.journalisation'),
                Icon: SvgJournalisation,
                View: Journalisation,
                right: `homeJournalisation_${history.environment}`,
            },
            stats: {
                label: Translator.translate('general.stats'),
                Icon: SvgStats,
                View: Stats,
                right: `homeJournalisation_${history.environment}`,
            }
        };

        this.state = {
            tabList: this.getTabList()
        };
    }

    componentDidMount() {
        this.addOnEventSocket();
    }
    componentDidUpdate(prevProps) {
        const { boxMac } = this.props;
        if (prevProps.boxMac !== boxMac) {
            this.deleteOnEventSocket(prevProps.boxMac);
            this.addOnEventSocket();
        }
    }
    componentWillUnmount() {
        const { boxMac } = this.props;
        this.deleteOnEventSocket(boxMac);
    }

    addOnEventSocket = () => {
        const { homeId, boxMac } = this.props;
        if (boxMac)
            getMiddlewareSocketInstance()
                .on(`productStatusChange${boxMac}`, this.handleEventProductStatus)
                .on(`newProductFound${homeId}`, this.handleEventNewProductFound)
                .on(`boxStatusChange${boxMac}`, this.handleEventBoxStatus);
    };

    deleteOnEventSocket = boxMac => {
        const { homeId } = this.props;
        if (boxMac)
            getMiddlewareSocketInstance() &&
                getMiddlewareSocketInstance()
                    .removeListener(`productStatusChange${boxMac}`, this.handleEventProductStatus)
                    .removeListener(`newProductFound${homeId}`, this.handleEventNewProductFound)
                    .removeListener(`boxStatusChange${boxMac}`, this.handleEventBoxStatus);
    };

    handleEventBoxStatus = status => {
        const { history } = this.props;
        if (status) Toastr.success(Translator.translate(`${history.environment}.home.events.box.connected`));
        else Toastr.error(Translator.translate(`${history.environment}.home.events.box.disconnected`));
    };

    handleEventNewProductFound = ({ product }) => {
        const { history } = this.props;
        const mac = product.identifier.match(/.{1,2}/g).join(':');
        const type = product.type;
        const label = product.label;

        Toastr.success(
            Translator.translate(`${history.environment}.home.events.product.connected`, label, mac),
            Translator.translate(`${history.environment}.home.events.product.new`, type),
            { onclick: this.openProductsTab }
        );
    };

    handleEventProductStatus = ({ productMac, productStatus, productLabel, displayType }) => {
        const { history } = this.props;
        const mac = productMac.match(/.{1,2}/g).join(':');
        const type = displayType;
        if (productStatus === 'connected')
            Toastr.success(
                Translator.translate(`${history.environment}.home.events.product.connected`, productLabel, mac),
                Translator.translate(`${history.environment}.home.events.product.connectedTitle`, type),
                {
                    onclick: this.openProductsTab
                }
            );
        else if (productStatus === 'disconnected')
            Toastr.error(
                Translator.translate(`${history.environment}.home.events.product.disconnected`, productLabel, mac),
                Translator.translate(`${history.environment}.home.events.product.disconnectedTitle`, type),
                {
                    onclick: this.openProductsTab
                }
            );
    };

    openProductsTab = e => {
        const { tabList } = this.state;

        this.refSubmenu.handleChange(e, tabList.products.key);
    };

    getTabList = () => {
        const { profile, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        let res = {};
        let cpt = 0;
        Object.keys(this.allTabList).map(key => {
            const tab = this.allTabList[key];
            if (profile.get('admin') || userRights.includes(tab.right)) {
                tab['key'] = cpt;
                res[key] = tab;
                cpt++;
            }
        });
        return res;
    };

    render() {
        const { tabList } = this.state;
        const { homeLabel, boxId, boxVersion, homeId, boxMac, classes, history } = this.props;

        let subtitle = `HOME ID: ${homeId}`;
        if (boxId) subtitle = [`HOME ID: ${homeId}`, <br key="br" />, `BOX ID: ${boxId}`];
        return (
            <FHEContainer withBackIcon classContainer={classes.classContainer}>
                <FHETitle
                    title={homeLabel}
                    subTitle={subtitle}
                    suffixTitle={`${Translator.translate(`${history.environment}.centerName`)} (Mac: ${
                        boxMac ? boxMac.match(/.{1,2}/g).join(':') : ''
                    }, Version: ${boxVersion})`}
                    Icon={SvgHome}
                />
                <SubMenuVertical tabList={tabList} childRef={ref => (this.refSubmenu = ref)} />
            </FHEContainer>
        );
    }
}

const styles = theme => ({
    classContainer: {
        width: 'auto',
        [theme.breakpoints.down('md')]: {
            marginLeft: 50,
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: 30,
        },
    },
});

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);

    const home = selectors.getHomeByHomeId(state, homeId);
    const homeBox = selectors.getBoxByHomeId(state, homeId);
    return {
        profile: selectors.getProfile(state),
        homeId,
        home,
        homeLabel: home.get('label'),
        boxId: homeBox.get('boxId'),
        boxVersion: homeBox.get('firmwareVersion'),
        boxMac: homeBox.get('macAddress'),
    };
}

export default withRouter(renderEnvComponent('scenes/Home/details', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(HomeDetail))));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/details.js